module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_01.d2b99bb4.jpg";